<template lang="pug">
  div
    Section1Widget(v-if="section1Visible")
    b-card
      b-card-text
        Section2Widget(v-if="section2Visible")
        Section3Widget(v-if="section3Visible")
        Section4Widget(v-if="section4Visible")
        Section5Widget(v-if="section5Visible")
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Section1Widget from './components/Section1Widget.vue'
import Section2Widget from './components/Section2Widget.vue'
import Section3Widget from './components/Section3Widget.vue'
import Section4Widget from './components/Section4Widget.vue'
import Section5Widget from './components/Section5Widget.vue'
export default {
  name: 'Landing',
  components: {
    Section1Widget,
    Section2Widget,
    Section3Widget,
    Section4Widget,
    Section5Widget,
  },
  data: function(){
    return {
    }
  },
  computed:{
    section1Visible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section1'; }));
    },
    section2Visible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section2'; }));
    },
    section3Visible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section3'; }));
    },
    section4Visible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section4'; }));
    },
    section5Visible(){
      return Boolean(this.$root.configuration &&
        this.$root.configuration.properties.length &&
        this.$root.configuration.properties.find(p=>{return p.value==='active' && p.name === 'section5'; }));
    },
  }
}
</script>

